import React, { Ref, memo } from "react";

import styles from "./right-column-footer.module.scss";

interface Props {
  suggestions: string[];
  focus: boolean;
  ref?: Ref<HTMLUListElement> | undefined;
  onSelect: (text: string) => void;
}

export const AutocompleteSuggestion: React.FC<Props> = memo((props: Props) => {
  if (props.focus && props.suggestions.length > 0) {
    return (
      <div className={styles.messagesRepeatedWrapper}>
        <ul className={styles.messagesRepeatedList} ref={props.ref}>
          {props.suggestions.map((suggestion, index) => (
            <li className={styles.messageRepeated} key={index} onClick={(): void => props.onSelect(suggestion)}>
              {suggestion}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return <></>;
});

AutocompleteSuggestion.displayName = "AutocompleteSuggestion";
